<template>
    <div class="thankyou-page page">
        <main>
            <div class="thankyou">
                <div class="container-fluid h-100">
                    <div class="row justify-content-center h-100 align-items-center">
                        <div class="col-12 col-lg-6">
                            <div class="thankyou__header pb-24 text-center">
                                <h1 class="h1">{{ title }}</h1>
                                <p>{{ text }}</p>
                            </div>

<!--                            <div class="thankyou__body">-->
<!--                                <div class="thankyou__body&#45;&#45;part">-->
<!--                                    <span class="number">1</span>-->
<!--                                    <p>Pellentesque purus libero, vulputate quis enim commodo, pellentesque euismod ex.</p>-->
<!--                                </div>-->
<!--                                <div class="thankyou__body&#45;&#45;part">-->
<!--                                    <span class="number">2</span>-->
<!--                                    <p>Ut in semper augue. Nullam sagittis quam non ultrices placerat.</p>-->
<!--                                </div>-->
<!--                            </div>-->

                            <div class="thankyou__footer text-center">
                                <router-link :to="{ name: 'home' }" class="btn btn-grey">Terug naar overzicht</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
  export default {
    computed: {
      title(){
        return this.$loggedIn ? this.$store.state.apiData.info_fields.subscribed_updated_title : this.$store.state.apiData.info_fields.subscribed_title
      },
      text(){
        return this.$loggedIn ? this.$store.state.apiData.info_fields.subscribed_updated_text : this.$store.state.apiData.info_fields.subscribed_text
      }
    }
  }
</script>
